import { createReducer, on } from '@ngrx/store';
import { saveEndHours } from './end-hours.actions';

export const saveEndHoursReducer = (_: any, { value }: { value: any }): any =>
    value;

export const EndHoursReducer = createReducer(
    [],
    on(saveEndHours, saveEndHoursReducer),
);
